import { render } from "./user.html?vue&type=template&id=e78eb924&scoped=true&ts=true"
import script from "./user.ts?vue&type=script&lang=ts"
export * from "./user.ts?vue&type=script&lang=ts"

import "./user.scss?vue&type=style&index=0&id=e78eb924&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78eb924"]])

export default __exports__